import { AlertCircle, RefreshCw, WifiOff } from "lucide-react";

export function ErrorAlert({ message, onRetry }) {
  const isNetwork =
    message?.toLowerCase().includes("network") ||
    message?.toLowerCase().includes("connect");
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mb-4">
        {isNetwork ? (
          <WifiOff className="w-7 h-7 text-red-400" />
        ) : (
          <AlertCircle className="w-7 h-7 text-red-400" />
        )}
      </div>
      <p className="text-sm font-semibold text-gray-700 mb-1">
        {isNetwork ? "Tidak dapat terhubung ke server" : "Gagal memuat data"}
      </p>
      <p className="text-xs text-gray-400 mb-5 max-w-xs">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2.5 bg-primary-800 text-white text-sm font-semibold rounded-xl hover:bg-primary-900 transition-colors"
        >
          <RefreshCw className="w-4 h-4" />
          Coba Lagi
        </button>
      )}
    </div>
  );
}

export function InlineError({ message }) {
  if (!message) return null;
  return (
    <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-xl text-sm text-red-600">
      <AlertCircle className="w-4 h-4 flex-shrink-0" />
      {message}
    </div>
  );
}
